export default __webpack_public_path__ + "static/media/2C61CD54-AA69-401D-897F-6BB81CB733C2_1_105_c.ad30be51.jpeg";